import styled from "styled-components";
import { RenderFields } from "../../utils/form.utils";
import Loading from "../Loading";

export default function FormSectionContainer({
  loading,
  setValue,
  fields,
  control,
  watch,
  errors,
  unregister,
  children
}) {
  return (
    <Section className="rounded p-3 my-3">
      {children}
      <Loading loading={loading} />
      <RenderFields
        setValue={setValue}
        fields={fields}
        control={control}
        watch={watch}
        errors={errors}
        unregister={unregister}
      />
    </Section>
  );
}

const Section = styled.div`
  background-color: #f8f9fa;
`;
